import React from 'react';
import PropTypes from 'prop-types';
import ConversationStatus from '../../ConversationStatus';
import ActionOptionsDropdown from '../ActionOptionsDropDown/ActionOptionsDropdown';
import ConversationType from '../../ConversationType';
import classNames from 'classnames';
import { Translate } from '@above-the-treeline/localization';
import { useAccountOrMembershipRequiredModalContext } from '../../../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';
import { useUser } from '../../../User/containers/UserDataStore';
import './headerActionOptions.less';

HeaderActionOptions.propTypes = {
	changeStatus: PropTypes.func,
	communitiesWithThreads: PropTypes.number,
	isMobile: PropTypes.bool,
	goToCommunityOptions: PropTypes.func,
	status: PropTypes.string,
	type: PropTypes.object,
};

function HeaderActionOptions({
	changeStatus,
	communitiesWithThreads,
	isMobile,
	goToCommunityOptions,
	status,
	type,
}) {
	const {
		setIsVisible,
		isNonMember,
	} = useAccountOrMembershipRequiredModalContext();
	const isAnonymous = useUser().isAnonymous();

	const handleChangeStatus = status => {
		return isNonMember() ? setIsVisible(true) : changeStatus(status);
	};

	const markUnreadButton = (
		<span
			className="acc-font"
			onClick={() => handleChangeStatus(ConversationStatus.active)}>
			<Translate id="mark_unread" />
		</span>
	);

	const archiveButton = (
		<span
			className="acc-font"
			onClick={() => handleChangeStatus(ConversationStatus.archived)}>
			<Translate id="archive" />
		</span>
	);

	const readConversationActionButtons = (
		<div className="conversation-action-buttons">
			{markUnreadButton}
			<div className="column">&nbsp;&bull;&nbsp;</div>
			{archiveButton}
		</div>
	);

	const unarchiveButton = (
		<span
			className="acc-font"
			onClick={() => handleChangeStatus(ConversationStatus.read)}>
			<Translate id="unarchive" />
		</span>
	);

	const renderStartConvoInOtherCommunities = () => {
		return (
			<span
				className="other-communities-option acc-font"
				onClick={() =>
					isAnonymous ? setIsVisible(true) : goToCommunityOptions()
				}>
				{communitiesWithThreads > 1 ? (
					<span className="other-conversations-title">
						{communitiesWithThreads - 1 > 1 ? (
							<Translate
								id="x_other_conversations"
								data={{
									conversationAmount:
										communitiesWithThreads - 1,
								}}
							/>
						) : (
							<Translate
								id="x_other_conversation"
								data={{
									conversationAmount:
										communitiesWithThreads - 1,
								}}
							/>
						)}
					</span>
				) : (
					<Translate id="start_conversation_in_another_community" />
				)}
			</span>
		);
	};

	const renderHeaderBottomDesktop = () => (
		<>
			{type === ConversationType.Title &&
				renderStartConvoInOtherCommunities()}
			<div className="conversation-action-container">
				{status === ConversationStatus.read &&
					readConversationActionButtons}
				{status === ConversationStatus.archived && unarchiveButton}
			</div>
		</>
	);

	const getHeaderActionOptionsClasses = () =>
		classNames('header-action-options', {
			isMobile: isMobile,
			isDesktop: !isMobile,
		});

	return (
		<div className={getHeaderActionOptionsClasses()}>
			{!isMobile ? (
				renderHeaderBottomDesktop()
			) : (
				<ActionOptionsDropdown
					markUnreadButton={markUnreadButton}
					unarchiveButton={unarchiveButton}
					archiveButton={archiveButton}
					startConvoInOtherCommunitiesButton={renderStartConvoInOtherCommunities(
						communitiesWithThreads,
					)}
					status={status}
					type={type}
				/>
			)}
		</div>
	);
}

export default HeaderActionOptions;
